export { type SimulateReactInputTargetState, simulateReactInput } from './simulateReactInput';
